import { render, staticRenderFns } from "./missedCalls.vue?vue&type=template&id=0a64ebd8&scoped=true&"
import script from "./missedCalls.vue?vue&type=script&lang=js&"
export * from "./missedCalls.vue?vue&type=script&lang=js&"
import style0 from "./missedCalls.vue?vue&type=style&index=0&id=0a64ebd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a64ebd8",
  null
  
)

export default component.exports